import { render, staticRenderFns } from "./service-pro.vue?vue&type=template&id=3a059108&scoped=true&"
import script from "./service-pro.vue?vue&type=script&lang=js&"
export * from "./service-pro.vue?vue&type=script&lang=js&"
import style0 from "./service-pro.vue?vue&type=style&index=0&id=3a059108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a059108",
  null
  
)

export default component.exports